






































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { HandleDirective } from 'vue-slicksort'
import SlickListItem from 'components/SlickListItem.vue'
import confirm from 'components/modals/Confirm'
import FileForm from 'components/presenter/item/topic/editor/InfoEditorFileForm.vue'
import api from 'src/assets/api/gql'
import rest from 'src/assets/api/rest'
import ItemAttachmentDelete from 'src/graphql/item/ItemAttachmentDelete.gql'
import { Item } from 'src/graphql/types'

@Component({
  directives: { handle: HandleDirective },
  components: {
    SlickListItem,
    FileForm
  }
})
export default class ItemTopicInfoEditorFileListItem extends Vue {
  loading = false

  @Prop()
  readonly item!: Item

  @Prop()
  readonly file!: Json

  @Prop()
  readonly editable!: boolean

  @Prop()
  readonly reorder!: boolean

  @Ref()
  readonly dialog!: FileForm

  edit () {
    if (this.editable) {
      this.dialog.show()
    }
  }

  async remove () {
    await confirm({
      title: this.$t('item.edit.files.del').toString(),
      message: this.file.name,
      btnRight: this.$t('label.delete').toString(),
      btnRightColor: 'warning'
    })
    this.loading = true
    const infoSettings: Json = {}
    infoSettings[`files:${this.file.id}:deleted`] = new Date().getTime()
    infoSettings[`files:${this.file.id}:sort`] = null
    infoSettings[`files:${this.file.id}:url`] = null
    infoSettings[`files:${this.file.id}:name`] = null
    infoSettings[`files:${this.file.id}:hide`] = null
    await this.item.data?.save({ infoSettings })
    this.loading = false
  }
}
